import React, { FC, useState } from 'react';
import { reportDesktopView, reportMobileView, reportTabletView } from '../../utils/bi';
import { VIEW_MODE } from '../../utils/helpers';
import { UIContext, UIContextShape } from './UIContext';

export const UIContextProvider: FC = ({ children }) => {
  const [viewMode, setViewMode] = useState(VIEW_MODE.DESKTOP);
  const [isInfoShown, setIsInfoShown] = useState(false);

  const toggleViewMode = (newValue: VIEW_MODE) => {
    if (viewMode === VIEW_MODE.DESKTOP) {
      reportDesktopView();
    }
    if (viewMode === VIEW_MODE.TABLET) {
      reportTabletView();
    }
    if (viewMode === VIEW_MODE.MOBILE) {
      reportMobileView();
    }

    setViewMode(newValue);
  };

  const contextValue: UIContextShape = {
    viewMode,
    toggleViewMode,
    isInfoShown,
    setIsInfoShown,
  };

  return <UIContext.Provider value={contextValue}>{children}</UIContext.Provider>;
};
